import axios from 'axios';

const API_BASE_URL = 'https://vitaldev.vitalinsights.in';

// Create axios instance with interceptors
const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Get lab results by appointment ID
export const getLabResultsByAppointmentId = async (appointmentId) => {
  try {
    const response = await api.get(`/admin/lab-results/by-appointment/${appointmentId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching lab results:', error);
    throw error;
  }
};

// Create or update lab result
export const saveLabResult = async (labResultData) => {
  try {
    const response = await api.post('/admin/lab-results', labResultData);
    return response.data;
  } catch (error) {
    console.error('Error saving lab result:', error);
    throw error;
  }
};

// Load lab results from external source
export const loadLabResults = async (appointmentId) => {
  try {
    const response = await api.post(`/admin/lab-results/load/${appointmentId}`);
    return response.data;
  } catch (error) {
    console.error('Error loading lab results:', error);
    throw error;
  }
};

export const labResultsService = {
  getLabResultsByAppointmentId,
  saveLabResult,
  loadLabResults
};
